module.exports = __webpack_public_path__ + "img/p60-xinwen-ziliao-chuangkan.7a3ee5c6.jpg";